import { z } from "zod";

import { apiGetList, apiMutate } from "@/lib/api/client";

const authSessionSchema = z.object({
  id: z.string(),
  deviceName: z.string().nullable(),
  userAgent: z.string().nullable(),
  ipAddress: z.string().nullable(),
  createdAt: z.string(),
  lastActivityAt: z.string(),
  expiresAt: z.string(),
  current: z.boolean(),
});

export type AuthSession = z.infer<typeof authSessionSchema>;

function newIdempotencyKey(): string {
  return crypto.randomUUID();
}

export async function fetchAuthSessions(signal?: AbortSignal): Promise<AuthSession[]> {
  const response = await apiGetList<unknown>("/auth/sessions", {}, signal);
  return z.array(authSessionSchema).parse(response.data);
}

export async function revokeAuthSession(sessionId: string): Promise<void> {
  await apiMutate<unknown>("POST", "/auth/sessions/revoke", {
    body: { sessionId },
    idempotencyKey: newIdempotencyKey(),
  });
}

export async function revokeAllOtherAuthSessions(): Promise<void> {
  await apiMutate<unknown>("POST", "/auth/sessions/revoke-all", {
    body: undefined,
    idempotencyKey: newIdempotencyKey(),
  });
}
